import { useState } from "react";
import { useI18n, type Language } from "../i18n";
import { SoundManager } from "../SoundManager";
import settingsIcon from "../assets/top settings.png";
import "./SettingsMenu.css";

const languages: { code: Language; name: string }[] = [
  { code: "en", name: "English" },
  { code: "fr", name: "Français" },
  { code: "it", name: "Italiano" },
  { code: "de", name: "Deutsch" },
  { code: "es", name: "Español" },
  { code: "tr", name: "Türkçe" },
  { code: "pt", name: "Português" },
  { code: "ru", name: "Русский" },
  { code: "zh", name: "中文" },
  { code: "ja", name: "日本語" },
  { code: "ko", name: "한국어" },
];

interface SettingsMenuProps {
  showBackButton?: boolean;
  onBack?: () => void;
  hidden?: boolean;
  fixed?: boolean;
  inline?: boolean;
}

export function SettingsMenu({
  showBackButton,
  onBack,
  hidden,
  fixed,
  inline,
}: SettingsMenuProps) {
  const { lang, setLanguage, t } = useI18n();
  const [isOpen, setIsOpen] = useState(false);
  const [isMuted, setIsMuted] = useState(() =>
    SoundManager.getInstance().isMuted(),
  );

  const handleToggleSound = () => {
    const soundManager = SoundManager.getInstance();
    soundManager.setMuted(!isMuted);
    setIsMuted(!isMuted);
  };

  const handleSelectLanguage = (code: Language) => {
    setLanguage(code);
  };

  const handleBack = () => {
    setIsOpen(false);
    onBack?.();
  };

  if (hidden) return null;

  return (
    <>
      <button
        className={`settings-button ${fixed ? "fixed" : ""} ${inline ? "inline" : ""}`}
        onClick={() => setIsOpen(true)}
        aria-label="Settings"
      >
        <img src={settingsIcon} alt="Settings" />
      </button>

      {isOpen && (
        <div className="settings-overlay" onClick={() => setIsOpen(false)}>
          <div className="settings-panel" onClick={(e) => e.stopPropagation()}>
            <div className="settings-content">
              {/* Sound toggle */}
              <div className="settings-row sound-row">
                <span className="sound-label">{t.sound}</span>
                <label className="sound-switch">
                  <input
                    type="checkbox"
                    checked={!isMuted}
                    onChange={handleToggleSound}
                  />
                  <span className="sound-slider"></span>
                </label>
              </div>

              {/* Language picker */}
              <div className="settings-row language-row">
                <span className="language-label">{t.language}</span>
                <select
                  className="language-select"
                  value={lang}
                  onChange={(e) =>
                    handleSelectLanguage(e.target.value as Language)
                  }
                >
                  {languages.map((l) => (
                    <option key={l.code} value={l.code}>
                      {l.name}
                    </option>
                  ))}
                </select>
              </div>

              <button className="close-btn" onClick={() => setIsOpen(false)}>
                ✕
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
